module.exports = "<div class=\"iframe-container\">\n  <button class=\"close-button\" (click)=\"closeIframe()\">Cerrar</button>\n  <iframe [src]=\"safeUrl\" frameborder=\"0\" allowfullscreen></iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/utils/fullscreen/full-screen-iframe.component.html
// module id = ../../../../../src/app/components/utils/fullscreen/full-screen-iframe.component.html
// module chunks = main